import { render, staticRenderFns } from "./StockTransactions.vue?vue&type=template&id=31795b16&scoped=true&"
import script from "./StockTransactions.vue?vue&type=script&lang=js&"
export * from "./StockTransactions.vue?vue&type=script&lang=js&"
import style0 from "./StockTransactions.vue?vue&type=style&index=0&id=31795b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31795b16",
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtn,QInput,QTable,QTr,QTh,QTd,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtn,QInput,QTable,QTr,QTh,QTd,QTooltip})
